module.exports = __webpack_public_path__ + "static/media/zoe.c3f38298.jpg";